import React, { useContext, useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import "./CheckoutFormStripe.css";
import { serverInfo } from "../../../App";
import swal from "sweetalert";
export default function CheckoutFormStripe({
  clientSecret,
  amount,
  event_type,
  event_id,
  buffer,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const cardElement = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  //for stripe payment redirectr
  const { domin } = useContext(serverInfo);


  useEffect(() => {
    if (buffer) {
      if (!stripe) {
        return;
      }

      if (!clientSecret) {
        return;
      }

      stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {

        switch (paymentIntent.status) {
          case "succeeded":
            swal("Success", "Payment succeeded!", "success");
            break;
          case "processing":
            swal("Warning", "Your payment is processing.","warning");
            break;
          case "requires_payment_method":
            swal("Error", "Your payment was not successful, please try again.", "error");
            break;
          default:
            swal("Error", "Something went wrong.", "error");
            break;
        }
      });
    }
  }, [buffer]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: domin,
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      <button
        className="stripe-btn"
        disabled={isLoading || !stripe || !elements}
        id="submit"
      >
        ({"$" + amount}){"  "}
        <span id="button-text">
          {isLoading ? (
            <div className="stripe_spinner" id="stripe_spinner"></div>
          ) : (
            "Pay Now"
          )}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
